export const about_section_data = [
    {
        "title" : "Welcome to Artisana Visuals",
        "text" : "At Artisana Visuals, we are not just a team of editors; we are architects of visual experiences, dedicated to transforming concepts into captivating realities. Our passion for delivering unparalleled quality is the driving force behind every project we undertake."
    },
    {
        "title" : "Who We Are:",
        "text" : "Artisana Visuals is a tight-knit collective of creative minds, each contributing a unique set of skills to our collaborative efforts. As a team, we understand the power of visuals in storytelling, and we embrace the responsibility of bringing your ideas to life with precision and artistry."
    }
]